// extracted by mini-css-extract-plugin
export var cancelButton = "_m2-5";
export var content = "_m2-3";
export var createButton = "_m2-6";
export var drawerContainer = "_m2-0";
export var footer = "_m2-2";
export var header = "_m2-1";
export var orderFormColumn = "_m2-4";